import { getCookie } from "../../../../utils/cookie";
import apiRequest from "../../../../utils/apiClient";
import { cancelMyCreationUrl } from "../../../constants";
import { EXPORT_CANCEL_ERROR } from "../constants/myLibraryText";

/** Give up on an export that is still processing. Resolves true when the server marked it cancelled. */
export const cancelCreation = async (creationId: number, messageStore: any): Promise<boolean> => {
  try {
    const response = await apiRequest(cancelMyCreationUrl, {
      method: "POST",
      mode: "cors",
      body: new URLSearchParams({ creation_id: creationId.toString() }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRFToken": getCookie("csrftoken"),
      },
    });
    const result = await response.json().catch(() => ({}));
    if (response.ok) return true;
    messageStore.setMessage(result.message || EXPORT_CANCEL_ERROR, "error");
    return false;
  } catch (error: any) {
    messageStore.setMessage(`${EXPORT_CANCEL_ERROR}: ${error.message}`, "error");
    return false;
  }
};
